export enum PasswordUpdateStatusCode {
    Success = 0,
    PasswordHistoryError = 1000,
}
